import React, { useState } from 'react';

function TruncatedText({ text, maxLength }: {text:string, maxLength:number}) {
    
  const [isTruncated, setIsTruncated] = useState(true);

  const truncatedText = isTruncated ? text.slice(0, maxLength) : text;

  const toggleTruncate = () => {
    setIsTruncated(!isTruncated);
  };

  return (
    <div>
      {truncatedText}
      {text.length > maxLength && <button onClick={toggleTruncate}>{isTruncated ? 'Show More' : 'Show Less'}</button>}
    </div>
  );
}

export default TruncatedText;
